import { Spin } from "antd";
import { IData, ITextInputErrorWarning } from "../../../store/@types/misc";
import { twMerge } from "tailwind-merge";
import React from "react";

type ISelectInput = {
  label: string;
  labelClassName?: string;
  name: string;
  status: ITextInputErrorWarning;
  loading?: boolean;
  items: IData[];
  icon?: React.ReactNode;
  value?: string | number;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
};
const SelectInput: React.FC<ISelectInput> = ({
  label,
  labelClassName,
  items,
  name,
  value,
  status,
  onChange,
  icon,
  loading,
  className,
}) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const borderColor = status ? "border-[red]" : "border-[#e5e7eb]";

  return (
    <div className="w-full">
      {/* Label */}
      <label className={twMerge("text-md font-medium", labelClassName)}>
        {label}
      </label>

      {/* Select Input Container */}
      <div
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className={twMerge(
          `flex w-full border items-center rounded-lg mt-1 text-gray-900 px-3 py-2 ${
            isFocused ? "border-primary-500" : borderColor
          } 
          focus-within:ring focus-within:ring-primary-100/30 transition-all`,
        )}
      >
        {/* Icon */}
        {icon && <div className="mr-1 border-r pr-2">{icon}</div>}

        {/* Select Element */}
        <select
          onChange={onChange}
          name={name}
          value={value}
          className={twMerge(
            "w-full !outline-none px-0 py-0 border-none focus:border-transparent focus:ring-0 bg-white bg-opacity-0",
            className,
          )}
        >
          <option value="">Please Select</option>
          {items.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Loading Spinner */}
        {loading && <Spin size="small" />}
      </div>
    </div>
  );
};

export default SelectInput;
